import TraderLayout from '../components/TraderLayout';
import {WithdrawalWorkspace} from '../withdrawals/WithdrawalWorkspace';
export default function TraderWithdraw(){return <TraderLayout><WithdrawalWorkspace/></TraderLayout>;}